import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { AdminService, UserSubscription } from './admin.service';
import { UserService } from './user.service';

@Injectable()
export class ResolverUserSubsService implements Resolve<UserSubscription[]> {

	constructor(
		private adminService: AdminService,
		private userService: UserService
	) { }

	async resolve(route: ActivatedRouteSnapshot): Promise<UserSubscription[]> {
		const userSubs = await new Promise<UserSubscription[]>((resolve, reject) => {
			const userSubsType = route.data.userSubsType;
			let email;
			if (userSubsType) {
				email = this.userService.getUserInfo().userEmail;
			} else {
				email = null;
			}
			// switch (userSubsType) {
			// 	case 'all':
			// 		email = null;
			// 		break;
			// 	case 'currentUser':
			// 		email = this.userService.getUserInfo().userEmail;
			// }
			// if userSubscriptions data exist or userSubsType is currentuser call getUserSubscriptions
			// if (!this.adminService.userSubscriptions) {
				this.adminService.getUserSubscriptions(email, null, true, null, (rsp) => {
					resolve(rsp);
				}, (err) => {
					console.log('Failed to get user subscriptions.');
					resolve([]);
				});
			// } else {
			// 	resolve(this.adminService.userSubscriptions);
			// }
		});
		return userSubs;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-user-subs.service.ts